module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pre"
    }
  }, [_vm._v("Preface and Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfma"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/int"
    }
  }, [_vm._v("Introduction: A Black Founder’s Many Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("1 “For Zion’s Sake … I Will Not Rest”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Gospel Labors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Year of the Fever, Part 1: A (Deceptively) Simple Narrative of the Black People")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Year of the Fever, Part 2: Allen’s Antislavery Appeal")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 “We Participate in Common”: Allen’s Role as a Black Mediator")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 A Liberating Theology: Establishing the AME Church")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Stay or Go? Allen and African Colonization")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Allen Challenged: Shadow Politics and Community Conflict in the 1820s")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 A Black Founder’s Expanding Visions")])]), _vm._v(" "), _c('p', {
    staticClass: "toccc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Last Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Richard Allen and the Soul of Black Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfma"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 72
// module chunks = 0